//tooltips description
export const STANDARD_DEVIATION_DESCRIPTION = `<div>The statistical measure of market volatility, measuring how widely prices are dispersed from the average price.
Put simply, it gives you an indication of how much the underlying's price can move from its mean level.</div></br>
<div> As per the probability density function of the Standard Normal distribution - There is a <strong> 68% </strong> chance that the movement would be within ( +1SD ) and ( -1SD ) limits, and a <strong> 95% </strong> chance that it will stay between ( +2SD ) and ( -2SD ) limits.</div>`;

export const STRIKEWISE_IVS_DESCRIPTION = `<div>Implied Volatility (IV) indicates the extent to which the market anticipates the underlying to move over the duration of the option's existence.
Thus, when IV rises, option premiums also rise.</div></br>
<div> The Strikewise IV field on uTrade Algos is completely interactive, meaning for each derivatives contract listed - you could enter the IV value
as per your anlysis and see the changes on the Blue line in the Graph tab and on the Target P&L in the P&L table tab. </div>`;

export const TARGET_PRICE_DESCRIPTION = `<div>The Target Price is calculated from the theoretical option price using the Black Scholes Model. It depends on variables such as the time to expiration
and volatility among others. You can change both of these parameters:</div></br>
<div>(i) Using the Target Date Slider to change the value of Time to expiry</div>
<div>(ii) Using the Strikewise IV option to enter the IV value for each derivatives contract.</div></br>
<div>The actual price of the contracts need not match the theoretical option price. This could be because of change in the value of these parameters due to market volatility, low liquidity in the
contract and so on.</div></br>
<div>Hence, the Projected P&L might not match the actual P&L at times.</div>`;

export const TARGET_PnL_DESCRIPTION = `The expected payout calculated taking into account the calculated Target Price and your entry price for the derivatives contract`;

export const TARGET_SPOT_DESCRIPTION = `You can input the current market value of the underlying asset on the specified date, based on your analysis, and review the corresponding
impact it will have on your target profit and loss (P&L) outcomes via the P&L table.`

export const GreekResponseStringsMap = {
    delta: `<div> Estimation of change of option value with change of Rs 1 in stock keeping everything else constant. </div></br>
    <div> Eg. Delta of 20 means you gain Rs. 20 when stock goes up by 1 Re and lose Rs. 20 when stock goes down by 1 Re.</div>
    </div> Similarly, Delta of -20 means the reverse. </div>`,
    theta: `<div> Theta indicates the loss of value of an options contract for each day it nears its expiration date keeping everything else constant. </div> </br>
    <div> Eg. A theta of <strong> -50 </strong> means you <strong> lose 50Rs. </strong> per day. Theta is negative i.e. it works against you if you're a <strong> Net Buyer </strong>. </div>
    <div> Theta could also be <strong> +50 </strong>, if you'e a <strong> Net Seller </strong>. This means you'll earn 50Rs per day as the contract approaches expiry. </div>`,
    rho: `The rate at which the price of a derivative changes relative to a change in the risk-free
      rate of interest`,
    gamma: `Gamma is the rate of change of Delta for every 1 unit movement in underlying price. A greater Gamma suggests that the option's value will
    experience accelerated changes as the underlying stock moves up or down by 1 unit.`,
    vega: `<div> It is the amount of change in call/put prices corresponding to one-point change in the Implied Volatility (IV). </div> </br>
    <div> For eg . Vega of +100 means you gain 100 Rs when IV goes up from 8% to 9%, and lose 100 Rs when IV goes from 8% to 7%. Vega could also be negative 100, in which the reverse happens. </div>`,
};

export const StatsStringsMap = {
    maxProfit: ``,
    maxLoss: `<div>This field shows the Max Loss at 'expiry' day resulting from the unique combination of your strategy legs.</div></br>
    <div>Note that - Execution on uTrade Algos is on Intraday basis, so your actual P&L could be much different from what is shown here.
    Put simply, you're not holding the contract till Expiry and exercising it, and rather trading the derivatives contract itself on the same day.
    The payout thus depends on the movement of the options contract itself.</div>`,
    riskReward: ``,
    breakEven: `The spot price of the underlying at which the contract yields neither a profit nor a loss.`,
    marginNeeded: ``,
};

export const BACKTEST_STRINGS = {
  WINS_DESCRIPTION: `How many times your strategy booked the desired Target profit as defined by you`,

  LOSSES_DESCRIPTION: `How many times your strategy booked a stop loss, as defined by you`,

  WS_DESCRIPTION: `Winning streak i.e. how many maximum consecutive targets were booked`,

  LS_DESCRIPTION: `Losing streak i.e. the maximum streak of booking consecutive Stop Losses`,

  SIGNALS_DESCRIPTION: `How many times the entry conditions were met`,

  DRAWDOWN_DESCRIPTION: `A drawdown refers to how much an investment or trading account is down from
  the peak before it recovers back to the peak`,

  CALMAR_RATIO_DESCRIPTION: `<div> The Calmar ratio is a gauge of the performance of your strategy. It is a
  function of the fund's average compounded annual rate of return versus its maximum drawdown. Statistically,
  Calmar Ratio = Net P&L/Max Drawdown. </div>
  <div> The higher the Calmar ratio the better. Anything over 0.50 is considered good,
  and between 3.0 to 5.0 is really good. </div>`,

  MAX_TIME_RECOVER_DESCRIPTION: `Returns the maximum time to recover from a drawdown`
};


